var _path, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "126px",
    height: "28px",
    viewBox: "0 0 126 28",
    enableBackground: "new 0 0 126 28",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D21A1A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M119.348,6.315c0.697-1.352,2.037-2.266,3.574-2.266"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M110.28,4.049c2.257,0,4.085,1.97,4.085,4.4v10.307c0,2.43-1.828,4.399-4.085,4.399H94.938c-2.257,0-4.085-1.97-4.085-4.399 v-5.838"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M90.853,13.131c0-2.431,1.828-4.401,4.085-4.401h15.343"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M90.853,18.756c0,2.43,1.828,4.399,4.085,4.399h15.343c2.257,0,4.085-1.97,4.085-4.399V8.449c0-2.43-1.828-4.4-4.085-4.4H94.938"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M122.922,23.155c-2.257,0-4.086-1.97-4.086-4.399v-8.732"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.935,18.324c0-6.028-9.016-3.096-9.016-9.721c0-3.965,3.231-4.942,5.756-4.942 c2.037,0,4.562,0.679,4.562,1.656c0,0.353-0.298,1.004-0.787,1.004c-0.516,0-1.412-1.031-3.801-1.031 c-2.009,0-3.938,0.733-3.938,3.149c0,5.051,9.016,2.2,9.016,9.721c0,3.856-2.39,5.595-5.73,5.595c-3.476,0-5.566-1.955-5.566-2.933 c0-0.436,0.407-1.006,0.815-1.006c0.706,0,1.249,2.255,4.643,2.255C9.414,22.072,10.935,20.796,10.935,18.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.39,15.501c0,2.091-1.167,2.172-2.362,2.172H18.89v1.005c0,2.173,1.738,3.53,4.128,3.53 c2.146,0,2.661-1.086,3.259-1.086c0.435,0,0.76,0.516,0.76,0.841c0,0.652-1.548,1.793-4.073,1.793 c-3.421,0-5.838-2.063-5.838-5.159v-3.042c0-2.715,2.335-4.997,5.187-4.997C25,10.558,27.39,12.622,27.39,15.501z M24.321,16.369 c1.086,0,1.358-0.163,1.358-0.923c0-1.738-1.385-3.422-3.395-3.422c-1.874,0-3.395,1.494-3.395,3.313v1.031H24.321z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.626,18.597v-2.905c0-2.879,1.629-5.133,5.241-5.133c2.308,0,3.828,1.032,3.828,1.765 c0,0.38-0.353,0.869-0.787,0.869c-0.516,0-0.978-1.004-2.96-1.004c-2.363,0-3.558,1.331-3.558,3.503v2.905 c0,2.199,1.195,3.529,3.584,3.529c2.091,0,2.525-1.031,3.069-1.031c0.489,0,0.814,0.461,0.814,0.868 c0,0.734-1.575,1.793-3.965,1.793C33.283,23.756,31.626,21.556,31.626,18.597z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M45.149,18.65V11.4c0-0.326,0.38-0.679,0.896-0.679c0.461,0,0.869,0.353,0.869,0.679v7.25 c0,1.765,1.493,3.476,3.395,3.476c1.873,0,3.394-1.684,3.394-3.476v-7.277c0-0.353,0.407-0.651,0.896-0.651 c0.489,0,0.869,0.298,0.869,0.651v7.277c0,2.715-2.362,5.105-5.159,5.105C47.457,23.756,45.149,21.338,45.149,18.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M66.138,12.188c-1.791,0-3.583,1.493-3.583,3.963v6.709c0,0.352-0.38,0.705-0.897,0.705 c-0.488,0-0.868-0.354-0.868-0.705V11.373c0-0.38,0.38-0.651,0.868-0.651c0.462,0,0.842,0.271,0.842,0.651v1.33 c0.597-1.085,1.873-2.145,3.638-2.145h0.951c0.381,0,0.706,0.38,0.706,0.815s-0.325,0.815-0.706,0.815H66.138z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M73.85,5.779c0,0.598-0.516,1.141-1.168,1.141c-0.678,0-1.221-0.543-1.221-1.141 c0-0.597,0.543-1.113,1.221-1.113C73.334,4.666,73.85,5.182,73.85,5.779z M73.578,11.373V22.86c0,0.352-0.406,0.705-0.896,0.705 c-0.488,0-0.868-0.354-0.868-0.705V11.373c0-0.38,0.38-0.651,0.868-0.651C73.172,10.722,73.578,10.993,73.578,11.373z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M80.803,10.722h3.881c0.381,0,0.625,0.353,0.625,0.706c0,0.407-0.244,0.76-0.625,0.76h-3.881v10.7 c0,0.405-0.436,0.678-0.925,0.678c-0.461,0-0.841-0.272-0.841-0.678V7.843c0-2.743,2.226-4.997,4.834-4.997h0.678 c0.462,0,0.76,0.38,0.76,0.815c0,0.407-0.298,0.787-0.76,0.787h-0.461c-1.875,0-3.26,1.521-3.285,3.258V10.722z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.609c20e3e862cd281d3d1d32691a1d94.svg";
export { ForwardRef as ReactComponent };